// Core
import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { Provider } from 'react-redux';

// Store
import { PersistGate } from 'redux-persist/integration/react';

// Container
import ApplicationBridge
    from './containers/application-bridge-container/ApplicationBridge';
import CountDownTimer
    from './containers/application-bridge-container/CountdownTimer';
import { BestPriceDisplay } from './containers/BestPriceDisplay';

import DialogErrorBoundary from './containers/dialog-error-boundary';
import ErrorBoundary from './containers/error-boundary';
import { StandaloneDatepicker } from './containers/StandaloneDatepicker';
import { ArchiveProducts } from './loaders/ArchiveProducts';
import { CartButton } from './loaders/CartButton';
import { ContinueButton } from './loaders/continue-button';
import { Giftcard } from './loaders/Giftcard';
import { HeaderMap } from './loaders/header-map';
import { ProductImage } from './loaders/product-image';
import { SearchInput } from './loaders/SearchInput';
import { SearchResults } from './loaders/SearchResults';
import { SingleProduct } from './loaders/single-product';
import { SoldOutStamp } from './loaders/SoldOutStamp';
import { StartPageSearchExperience } from './loaders/StartPageSearchExperience';

import createStore from './store/';

const {store, persistor} = createStore();

function render(
    Component,
    mountPoint,
    ErrorBoundaryComponent = ErrorBoundary,
    errorBoundaryProps = {},
) {
    if (!mountPoint) {
        return;
    }

    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <PersistGate
                    loading={null}
                    persistor={persistor}
                >
                    <ErrorBoundaryComponent {...errorBoundaryProps}>
                        <Component />
                    </ErrorBoundaryComponent>
                </PersistGate>
            </Provider>
        </AppContainer>,
        mountPoint,
    );
}

// Route
let startPage = document.getElementById('root-start-page');
render(StartPageSearchExperience, startPage);

let singleProduct = document.getElementById('root-single-product');
render(SingleProduct, singleProduct);

let soldOutStamp = document.getElementById('root-soldout-stamp');
let soldOutStampMobile = document.getElementById('root-soldout-stamp-mobile');
render(SoldOutStamp, soldOutStamp);
render(SoldOutStamp, soldOutStampMobile);

let cartButton = document.getElementById('root-cart-button');
render(CartButton, cartButton, DialogErrorBoundary);

let continueButtonMobile = document.getElementById('root-continue-button-mobile');
let continueButtonDesktop = document.getElementById(
    'root-continue-button-desktop');
render(ContinueButton, continueButtonMobile, DialogErrorBoundary);
render(ContinueButton, continueButtonDesktop, DialogErrorBoundary);

let archiveProducts = document.getElementById('root-archive-products');
render(ArchiveProducts, archiveProducts);

let headerMap = document.getElementById('root-header-map');
render(HeaderMap, headerMap, DialogErrorBoundary, {height: '100%'});

let productImage = document.getElementById('root-product-image');
render(ProductImage, productImage, DialogErrorBoundary, {height: '100%'});

let giftcard = document.getElementById('root-giftcard');
render(Giftcard, giftcard);

const searchResults = document.getElementById('root-search-results');
render(SearchResults, searchResults);

const searchInputs = [
    document.getElementById('root-search'),
    document.getElementById('flyout-search'),
];

for (let i = 0, l = searchInputs.length; i < l; ++i) {
    render(SearchInput, searchInputs[i]);
}

let applicationBridgeContainer = document.getElementById(
    'root-application-bridge-container');
render(
    ApplicationBridge,
    applicationBridgeContainer,
    DialogErrorBoundary,
);

const countDownTimer = document.getElementById('root-countdown-timer');
render(CountDownTimer, countDownTimer, DialogErrorBoundary);

const bestPriceDisplays = document.querySelectorAll('.root-best-price-display');
for (let i = 0, l = bestPriceDisplays.length; i < l; ++i) {
    render(BestPriceDisplay, bestPriceDisplays[i], (props) => props.children);
}

const datepicker = document.querySelector('.root-standalone-datepicker');
if (datepicker) {
    render(StandaloneDatepicker, datepicker);
}

// webpack Hot Module Replacement API
if (module.hot) {
    module.hot.accept('./containers/StartPageSearchExperience', () => {
        render(StartPageSearchExperience, startPage);
    });

    module.hot.accept('./containers/single-product', () => {
        render(SingleProduct, singleProduct);
    });

    module.hot.accept('./containers/SoldOutStamp', () => {
        render(SoldOutStamp, soldOutStamp);
    });

    module.hot.accept('./containers/SoldOutStamp', () => {
        render(SoldOutStamp, soldOutStampMobile);
    });

    module.hot.accept('./containers/CartButton', () => {
        render(CartButton, cartButton, DialogErrorBoundary);
    });

    module.hot.accept('./containers/ArchiveProducts', () => {
        render(ArchiveProducts, archiveProducts);
    });

    module.hot.accept('./containers/header-map', () => {
        render(HeaderMap, headerMap, DialogErrorBoundary);
    });

    module.hot.accept('./containers/product-image', () => {
        render(ProductImage, productImage, DialogErrorBoundary);
    });

    module.hot.accept('./containers/Giftcard', () => {
        render(Giftcard, giftcard);
    });

    module.hot.accept('./containers/SearchResults', () => {
        render(SearchResults, searchResults);
    });

    module.hot.accept('./containers/SearchInput', () => {
        for (let i = 0, l = searchInputs.length; i < l; ++i) {
            render(SearchInput, searchInputs[i]);
        }
    });

    module.hot.accept(
        './containers/application-bridge-container/ApplicationBridge',
        () => {
            render(
                ApplicationBridge,
                applicationBridgeContainer,
                DialogErrorBoundary,
            );
        },
    );

    module.hot.accept(
        './containers/application-bridge-container/CountdownTimer',
        () => {
            render(CountDownTimer, countDownTimer, DialogErrorBoundary);
        },
    );

    module.hot.accept('./containers/BestPriceDisplay', () => {
        for (let i = 0, l = bestPriceDisplays.length; i < l; ++i) {
            render(
                BestPriceDisplay,
                bestPriceDisplays[i],
                (props) => props.children,
            );
        }
    });
}
